import {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router'
import {Centre} from 'brand/Centre'
import {Spinner} from 'brand/Spinner'

import cameraButton from './icon-camera-button.svg'

export const SelfieCamera = ({setSelfieData}) => {
  const nav = useNavigate()

  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const photoRef = useRef(null)
  const [showPhoto, setShowPhoto] = useState(false)
  const [streaming, setStreaming] = useState(false)

  const attachCamera = async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
      console.warn('getUserMedia not supported!')
      return
    }
    const ideal = 512
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {width: {ideal}, height: {ideal}},
      facingMode: 'user',
    })
    if (!stream) {
      console.warn("Couldn't find user-facing video source!")
      return
    }
    videoRef.current.srcObject = stream
  }

  const initStreamParams = () => {
    if (streaming) {
      return
    }
    setStreaming(true)
  }

  useEffect(() => { attachCamera() }, [])

  const takeFullPhoto = () => {
    if (showPhoto) {
      setShowPhoto(false)
      return
    }
    setShowPhoto(true)

    const video = videoRef.current
    const videoSize = {w: video.videoWidth, h: video.videoHeight}
    console.debug(`Video size: ${videoSize.w}x${videoSize.h}`)

    const canvas = canvasRef.current
    canvas.width = videoSize.w
    canvas.height = videoSize.h

    canvas.getContext('2d')
      .drawImage(videoRef.current, 0, 0, videoSize.w, videoSize.h)

    const photoData = canvas.toDataURL('image/png')
    photoRef.current.setAttribute('src', photoData)
    setSelfieData(photoData)
  }

  const takeCroppedPhoto = () => {
    if (showPhoto) {
      setShowPhoto(false)
      return
    }
    setShowPhoto(true)

    const video = videoRef.current
    const videoSize = {w: video.videoWidth, h: video.videoHeight}
    const clientSize = {w: video.clientWidth, h: video.clientHeight}
    console.debug(`Video size: ${videoSize.w}x${videoSize.h}`)
    console.debug(`Cropped size: ${clientSize.w}x${clientSize.h}`)

    const canvas = canvasRef.current
    canvas.width = clientSize.w
    canvas.height = clientSize.h
    const shrunkW = (clientSize.h * videoSize.w) / videoSize.h
    const xOffset = (shrunkW - clientSize.w) / 2

    canvas.getContext('2d')
      .drawImage(videoRef.current, -xOffset, 0, shrunkW, clientSize.h)

    const photoData = canvas.toDataURL('image/png')
    photoRef.current.setAttribute('src', photoData)
    setSelfieData(photoData)
  }

  const endCameraStream = () => {
    videoRef.current.srcObject.getTracks()
      .filter(it => it.readyState === 'live')
      .forEach(it => { it.stop() })
  }

  const takePhoto = () => {
    takeFullPhoto()
    // takeCroppedPhoto()
    endCameraStream()
    setTimeout(() => nav('/consult/selfie/preview'), 500)
  }

  return (
    <div className="fullscreen-avoiding-chrome column">
      <div className="camera-feed">
        <Centre><Spinner tone="highlight" /></Centre>
        <video autoPlay playsInline className="float-cover" ref={videoRef} onCanPlay={() => initStreamParams()} />
        <img className="float-cover" ref={photoRef} alt="Camera capture" style={{display: showPhoto ? 'initial' : 'none'}} />
      </div>
      <div className="camera-button">
        <button className="camera-button" onClick={takePhoto} disabled={!streaming}>
          <img src={cameraButton} alt="Camera button" />
        </button>
      </div>
      <canvas hidden ref={canvasRef} />
    </div>
  )
}
